<template>
  <div class="save-container">
    <SavingIcon v-show="saved" />
    <LoadIcon
      v-show="!saved"
      class="saving"
      :size="19"
    />
    <p>{{ displayText }}</p>
  </div>
</template>

<script>
import SavingIcon from '../svgs/SavingIcon.vue';
import LoadIcon from '../svgs/LoadIcon.vue';

export default {
  name: 'SaveStatus',
  components: {
    SavingIcon,
    LoadIcon,
  },
  props: {
    saved: {
      type: Date,
      default: null,
    },
    username: {
      type: String,
      default: '',
    },
  },
  computed: {
    displayText() {
      if (!this.saved) {
        return 'Saving...';
      }

      const today = new Date();
      const isToday = this.saved.toDateString() === today.toDateString();
      const dateStr = isToday ? 'Today' : this.saved.toLocaleDateString();
      const timeStr = this.saved.toLocaleTimeString();

      if (this.username) {
        return `Saved ${this.username}, ${dateStr}, ${timeStr}`;
      }

      return `Saved ${dateStr}, ${timeStr}`;
    },
  },
};
</script>

<style scoped lang="scss">
.save-container {
  display: flex;
  align-items: center;
  flex-direction: row;
  font-size: 12px;
  height: 32px;

  .saving {
    margin-left: 5px;
    margin-right: 5px;
  }

  p {
    margin: 0;
    white-space: nowrap;
    color: #666;
  }
}
</style>
